import { FC, useEffect, useState } from "react";
import { VacancyListItem } from "./VacancyListItem";
import { Empty } from "antd";
import { VacancyShortDto } from "../../types/jobs";
import { getVacancies } from "../../api/transport/jobsTransport";
import { Loader } from "../../components/Loader";
import { useTeamContext } from "../../hooks/useConfiguration";
import { getUrlByContext } from "../../utils";

interface VacanciesListProps { }

export const VacanciesList: FC<VacanciesListProps> = () => {
    const [vacancies, setVacancies] = useState<VacancyShortDto[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const teamContext = useTeamContext();

    useEffect(() => {
        setLoading(true);
        getVacancies(teamContext)
            .then((data) => {
                setVacancies(data);
            }).finally(() => {
                setLoading(false);
            });
    }, []);

    if (loading) {
        return <Loader />;
    }

    return (
        <div className="flex flex-col justify-start items-center gap-2 sm:gap-6">
            {vacancies.map((vacancy: VacancyShortDto) => (
                <VacancyListItem
                    key={vacancy.uuid}
                    title={vacancy.title}
                    url={getUrlByContext(`/jobs/${vacancy.uuid}/`, teamContext)}
                    description={vacancy.shortDescription}
                />
            ))}
            {
                vacancies.length === 0 && <Empty
                    description="У нас пока нет открытых вакансий, попробуйте заглянуть позже"
                />
            }
        </div>
    );
}